import React from 'react';

function App() {
  const handleRedirect = () => {
    window.location.href = 'https://www.lovableilimitado.com.br/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-400 via-pink-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 md:p-10 animate-[fadeIn_0.5s_ease-in-out]">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://static.lumi.new/d1/d109b55acb70141a2f02b65d27bf9696.webp"
            alt="Lovable"
            className="h-24 md:h-32 object-contain" />

        </div>

        {/* Mensagem */}
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
            Antes de entrar gratuitamente em nossa comunidade...
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed">Veja como usar a Lovable DE GRAÇA, ILIMITADA, e sem se preocupar em comprar créditos ou assinar os planos pagos da plataforma.

          </p>
          <p className="text-sm text-gray-500 mt-4 italic">O botão para entrar de graça na comunidade está ao final da próxima página.

          </p>
        </div>

        {/* Botão */}
        <button
          onClick={handleRedirect}
          className="w-full bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600 text-white font-semibold text-lg py-4 px-6 rounded-full hover:shadow-xl hover:scale-105 transition-all duration-300 ease-in-out">Quero Saber Como Usar a Lovable ILIMITADA


        </button>
      </div>
    </div>);

}

export default App;